<template>
  <div class="ticourses-view">
    <top-navbar></top-navbar>
    <div class="mb-5 background_color">
      <h6 class="manage-boder pt-2 font1 decoration">
        <router-link class="decoration" to="/">Home</router-link><span class="pfimg3"><i class="fa fa-angle-right"></i></span>
        <router-link class="decoration" to="/tinternalcourses/index">Internal Courses</router-link><span class="pfimg3"><i class="fa fa-angle-right"></i></span>
        {{ course.course_code || 'View Course' }}
      </h6>
      <div class="container-fluid">
        <div v-if="errorMessage" class="alert alert-danger">{{ errorMessage }}</div>
        <div v-if="isLoading" class="d-flex justify-content-center"><div class="spinner-border text-primary"></div></div>
        <template v-else>
          <div class="d-flex justify-content-between mb-2"><button type="button" class="btn btn-sm btn-outline-primary bdr-rad" @click="addSurveyQuestions">Add Survey Questions</button><router-link to="/tinternalcourses/index" class="btn btn-sm btn-outline-primary bdr-rad">Back</router-link></div>
          <div class="card custom_bdr_rds shadow p-2">
            <div class="card-body custom_bdr_rds">
              <table class="table table-sm table-borderless course-summary">
                <tbody>
                  <tr v-for="item in summaryFields" :key="item.label">
                    <td class="summary-label"><b>{{ item.label }}</b></td>
                    <td>{{ item.value || '-' }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="card custom_bdr_rds shadow p-2 mt-3">
            <div class="card-body custom_bdr_rds">
              <h6 class="purchitem mb-2"><b>Course Modules</b></h6>
              <div class="table-responsive">
                <table class="table table-hover table-sm table-borderless">
                  <thead class="background_color2"><tr class="custom-label2"><th>#</th><th>Module Name</th><th>Conduct By</th><th>Available Seats</th><th>Duration</th><th>Per Emp. Cost</th><th>Remarks</th><th>Actions</th></tr></thead>
                  <tbody><tr v-for="(item, index) in modules" :key="item.id"><td>{{ index + 1 }}</td><td>{{ item.module_name }}</td><td>{{ item.conduct_by }}</td><td>{{ item.available_seats }}</td><td>{{ item.duration }}</td><td>{{ item.per_employee_cost }}</td><td>{{ item.remarks || '-' }}</td><td class="text-nowrap"><button class="btn btn-sm btn-outline-primary bdr-rad mr-1" @click="editCourse">Update</button><button class="btn btn-sm btn-outline-primary bdr-rad" @click="deleteItem('module', item.id)">Delete</button></td></tr><tr v-if="!modules.length"><td colspan="8">No modules found.</td></tr></tbody>
                </table>
              </div>
            </div>
          </div>

          <div class="card custom_bdr_rds shadow p-2 mt-3">
            <div class="card-body custom_bdr_rds">
              <h6 class="purchitem mb-2"><b>Course Module Trainers</b></h6>
              <div class="table-responsive">
                <table class="table table-hover table-sm table-borderless">
                  <thead class="background_color2"><tr class="custom-label2"><th>#</th><th>Module Name</th><th>Trainer Type</th><th>Department</th><th>Trainer Name</th><th>Remarks</th><th>Actions</th></tr></thead>
                  <tbody><tr v-for="(item, index) in trainerRows" :key="item.id"><td>{{ index + 1 }}</td><td>{{ item.module_name }}</td><td>{{ item.trainer_type_name }}</td><td>{{ item.department || '-' }}</td><td>{{ item.trainer_name }}</td><td>{{ item.remarks || '-' }}</td><td class="text-nowrap"><button class="btn btn-sm btn-outline-primary bdr-rad mr-1" @click="editCourse">Update</button><button class="btn btn-sm btn-outline-primary bdr-rad" @click="deleteItem('trainer', item.id)">Delete</button></td></tr><tr v-if="!trainerRows.length"><td colspan="7">No trainers found.</td></tr></tbody>
                </table>
              </div>
            </div>
          </div>

          <div class="card custom_bdr_rds shadow p-2 mt-3">
            <div class="card-body custom_bdr_rds">
              <h6 class="purchitem mb-2"><b>Course Materials</b></h6>
              <div class="table-responsive">
                <table class="table table-hover table-sm table-borderless">
                  <thead class="background_color2"><tr class="custom-label2"><th>#</th><th>Module Name</th><th>Material Name</th><th>Material Type</th><th>File</th><th>Remarks</th><th>Actions</th></tr></thead>
                  <tbody><tr v-for="(item, index) in materialRows" :key="item.id"><td>{{ index + 1 }}</td><td>{{ item.module_name }}</td><td>{{ item.resource_name || '-' }}</td><td>{{ item.material_type || '-' }}</td><td><a v-if="item.file_path" :href="item.file_path" target="_blank">View File</a><span v-else>-</span></td><td>{{ item.remarks || '-' }}</td><td class="text-nowrap"><button class="btn btn-sm btn-outline-primary bdr-rad mr-1" @click="editCourse">Update</button><button class="btn btn-sm btn-outline-primary bdr-rad" @click="deleteItem('material', item.id)">Delete</button></td></tr><tr v-if="!materialRows.length"><td colspan="7">No materials found.</td></tr></tbody>
                </table>
              </div>
            </div>
          </div>

          <div class="card custom_bdr_rds shadow p-2 mt-3">
            <div class="card-body custom_bdr_rds">
              <h6 class="purchitem mb-2"><b>Capable Job Roles</b></h6>
              <div class="course-roles-count">Showing {{ jobRoles.length }} item<span v-if="jobRoles.length !== 1">s</span>.</div>
              <div class="table-responsive">
                <table class="table table-hover table-sm table-borderless">
                  <thead class="background_color2">
                    <tr class="custom-label2">
                      <th>#</th>
                      <th>Position</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(role, index) in jobRoles" :key="role.id || role.role_name || index">
                      <td>{{ index + 1 }}</td>
                      <td>{{ role.role_name || role }}</td>
                      <td><button class="btn btn-sm btn-outline-primary bdr-rad" @click="deleteItem('role', role.id)">Delete</button></td>
                    </tr>
                    <tr v-if="!jobRoles.length"><td colspan="3">No capable job roles found.</td></tr>
                  </tbody>
                </table>
              </div>
            </div>
          
          </div>
            <br><br><br>
        </template>
      </div>
    </div>
    <content-footer></content-footer>
  </div>
</template>

<script>
import axios from 'axios';
import authService from '@/auth.service';
import TopNavbar from './../../layout/TopNavbar.vue';
import ContentFooter from './../../layout/ContentFooter.vue';

export default {
  components: { TopNavbar, ContentFooter },
  data() { return { token: authService.isLoggedIn(), isLoading: true, errorMessage: '', course: {}, modules: [], trainers: [], materials: [], jobRoles: [], moduleFields: [{ key: 'number', label: '#' }, { key: 'module_name', label: 'Module Name' }, { key: 'conduct_by', label: 'Conduct By' }, { key: 'available_seats', label: 'Available Seats' }, { key: 'duration', label: 'Duration' }, { key: 'per_employee_cost', label: 'Per Emp. Cost' }, { key: 'remarks', label: 'Remarks' }], trainerFields: [{ key: 'module_name', label: 'Module Name' }, { key: 'trainer_type_name', label: 'Trainer Type' }, { key: 'department', label: 'Department' }, { key: 'trainer_name', label: 'Trainer Name' }, { key: 'remarks', label: 'Remarks' }], materialFields: [{ key: 'module_name', label: 'Module Name' }, { key: 'resource_name', label: 'Material Name' }, { key: 'material_type', label: 'Material Type' }, { key: 'file_path', label: 'File' }, { key: 'remarks', label: 'Remarks' }] }; },
  computed: {
    summaryFields() { return [{ label: 'Course Code', value: this.course.course_code }, { label: 'Training Category', value: this.course.training_category }, { label: 'Group', value: this.groupName(this.course.course_group) }, { label: 'Course Title', value: this.course.course_title }, { label: 'Internal Course', value: 'Internal' }, { label: 'Training Center', value: this.course.training_center_id }, { label: 'Duration', value: this.course.duration }, { label: 'Frequency', value: this.course.frequency }, { label: 'Allocated Seats', value: this.course.allocated_seats }, { label: 'Remarks', value: this.course.remarks }, { label: 'Created Date', value: this.course.created_date }, { label: 'Created By', value: this.course.created_by }, { label: 'Status', value: this.statusName(this.course.status) }]; },
    trainerRows() { return this.trainers.map((item) => ({ ...item, module_name: this.moduleName(item.module_id), trainer_type_name: Number(item.trainer_type) === 1 ? 'External' : 'Internal', trainer_name: item.external_trainer || item.internal_trainer_id || '-' })); },
    materialRows() { return this.materials.map((item) => ({ ...item, module_name: this.moduleName(item.module_id) })); },
  },
  mounted() { this.loadCourse(); },
  methods: {
    async loadCourse() { try { const { data } = await axios.get('/ticourses/view?id=' + this.$route.query.id, { headers: { Authorization: 'Bearer ' + this.token } }); this.course = data.course || {}; this.modules = data.modules || []; this.trainers = data.trainers || []; this.materials = data.materials || []; this.jobRoles = data.job_roles || []; } catch (error) { this.errorMessage = 'Unable to load internal course.'; } finally { this.isLoading = false; } },
    moduleName(id) { const module = this.modules.find((item) => Number(item.id) === Number(id)); return module ? module.module_name : '-'; },
    groupName(value) { return { 1: 'Refresher', 2: 'Renewal', 3: 'New' }[value] || value || '-'; },
    statusName(value) { return Number(value) === 1 ? 'Active' : 'Inactive'; },
    editCourse() { this.$router.push('/tinternalcourses/create?edit=' + this.course.id); },
    addSurveyQuestions() { this.$router.push('/tinternalcourses/survey-questions?course_id=' + this.course.id); },
    async deleteItem(type, id) {
      if (!id || !window.confirm('Are you sure you want to delete this record?')) return;
      try {
        await axios.delete('/ticourses/delete-item?type=' + type + '&id=' + id, { headers: { Authorization: 'Bearer ' + this.token } });
        await this.loadCourse();
      } catch (error) { this.errorMessage = 'Unable to delete record.'; }
    },
  },
};
</script>

<style>
.ticourses-view .course-summary { font-size: small; }
.ticourses-view .course-summary td { padding: 7px 5px; }
.ticourses-view .summary-label { width: 200px; }
.ticourses-view .course-roles-count { font-size: small; padding: 2px 0 6px; }
</style>
